import classNames from 'classnames';
import React from 'react';
import { isBuy, isRecurringBuy, isAppBuy } from 'src/utils/transactions-util';
import styles from './ExpandedFundClassificationTypeHeader.module.scss';

export interface ExpandedFundClassificationTypeHeaderProps {
  singleColumn?: boolean;
}

export const ExpandedFundClassificationTypeHeader: React.FC<
  ExpandedFundClassificationTypeHeaderProps
> = ({ children, singleColumn }) => (
  <header className={classNames('funds-row', styles['header'])}>
    <div className={classNames('funds-name-col', styles['classification'])}>
      {children}
    </div>
    {!singleColumn && (
      <React.Fragment>
        <div className={classNames('funds-notes-col', styles['notes'])}>
          Notes
        </div>
        <div className={classNames('funds-balance-col', styles['balance'])}>
          {isBuy() || isRecurringBuy() || isAppBuy()
            ? 'Balance*'
            : 'Available Balance*'}
        </div>
      </React.Fragment>
    )}
  </header>
);
